<template>
    <sui-dropdown
        selection
        fluid
        :options="appendPrependOptions"
        v-model="input"
        @input="onChange"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            input: this.value,
            appendPrependOptions: [{
                text: 'APPEND',
                value: 'APPEND',
            }, {
                text: 'PREPEND',
                value: 'PREPEND',
            }],
        };
    },
    watch: {
        value: {
            handler(value) {
                this.input = value;
            },
            immediate: true,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.input);
        }
    }
}
</script>